// i18n translations for MABW (Italian / English / German)
// Default language is Italian.

const translations = {
  it: {
    common: {
      loading: "Caricamento…",
      back: "← Indietro",
      cancel: "Annulla",
      submit: "Invia",
      save: "Salva",
      close: "Chiudi",
      send: "Invia",
      offers: "offerte",
      reviewsShort: "recensioni",
      from: "Da",
    },
    nav: {
      home: "Home",
      search: "Cerca Aiuto",
      new: "Nuova Richiesta",
      messages: "Messaggi",
      profile: "Profilo",
      map: "Mappa",
      wall: "Muro degli aiuti",
      login: "Accedi",
      register: "Unisciti",
      logout: "Esci",
    },
    footer: {
      tagline: "Aiuto gratuito tra persone. Nessun denaro. Nessuna pretesa. Solo solidarietà.",
    },
    status: {
      open: "Aperta",
      accepted: "In corso",
      completed: "Completata",
      cancelled: "Annullata",
    },
    categories: {
      home: { label: "Casa", hint: "Spesa, montaggio, traslochi" },
      transport: { label: "Trasporto", hint: "Accompagnamento e spostamenti" },
      study: { label: "Studio", hint: "Ripetizioni, compiti" },
      technology: { label: "Tecnologia", hint: "Supporto digitale di base" },
      pets: { label: "Animali", hint: "Cura e passeggiate" },
      elderly: { label: "Assistenza Anziani", hint: "Compagnia e ascolto" },
      gardening: { label: "Giardinaggio", hint: "Giardinaggio leggero" },
      other: { label: "Altro", hint: "Tutto il resto" },
      all: "Tutte",
    },
    badges: {
      new_member: { name: "Nuovo Membro", desc: "Benvenuto nella community" },
      active_member: { name: "Membro Attivo", desc: "3+ aiuti completati" },
      supporter: { name: "Sostenitore", desc: "10+ aiuti completati" },
      ambassador: { name: "Ambasciatore MABW", desc: "25+ aiuti completati" },
      world_builder: { name: "Costruttore di un Mondo Migliore", desc: "50+ aiuti completati" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "L'aiuto torna ad essere",
      hero_title_2: "un gesto umano",
      hero_title_3: ", non una transazione.",
      hero_subtitle: "MABW collega persone disposte ad aiutare con persone che hanno bisogno. Gratis. Volontario. Di persona. Senza debiti né scambi di denaro.",
      cta_join: "Unisciti gratis",
      cta_have_account: "Ho già un account",
      cta_enter_app: "Entra in MABW",
      members: "Membri",
      completed_helps: "Aiuti completati",
      open_requests: "Richieste aperte",
      in_person_title: "Solo di persona",
      in_person_desc: "Niente servizi online o consulenze a distanza.",
      principles_overline: "I nostri principi",
      principles_title: "Cinque valori, una sola direzione.",
      principles: {
        free: { t: "Gratuito", d: "Ogni attività è gratuita. Nessuna ricompensa economica." },
        voluntary: { t: "Volontario", d: "Ogni aiuto è libero. Nessuno è obbligato ad accettare." },
        respect: { t: "Rispetto", d: "Comportamento civile e relazioni di rispetto reciproco." },
        trust: { t: "Fiducia", d: "La community cresce sulla fiducia tra le persone." },
        community: { t: "Comunità", d: "Ogni piccolo gesto contribuisce al bene comune." },
      },
      cat_overline: "Cosa puoi chiedere o offrire",
      cat_title: "Piccoli gesti, grande impatto.",
      cat_sub: "Spesa, accompagnamento, compagnia agli anziani, supporto digitale, ripetizioni. Solo di persona.",
      badges_overline: "Riconoscimenti della community",
      badges_title: "Ogni gesto lascia un segno.",
      cta_box_title: "Fai parte di un mondo più umano.",
      cta_box_desc: "MAKE A BETTER WORLD inizia da un piccolo gesto. Unisciti oggi alla community MABW e dimostra che la solidarietà tra persone è ancora possibile.",
      cta_create: "Crea il tuo account",
      cta_login: "Accedi",
      cta_browse: "Vedi le richieste",
      support_overline: "Sostieni il progetto",
      support_title: "MABW vive grazie a chi crede in questa idea.",
      support_desc: "MABW è un progetto indipendente, senza pubblicità, senza commissioni e senza fini di lucro. Se vuoi contribuire a tenere viva e gratuita questa community, puoi sostenere lo sviluppo con una donazione libera. Ogni contributo, anche piccolo, aiuta a coprire i costi di hosting e a far crescere MABW.",
      support_cta: "Sostieni MABW",
      support_footer: "Sostieni il progetto",
    },
    auth: {
      login_title: "Bentornato",
      login_sub: "Accedi per continuare a costruire un mondo migliore.",
      email: "Email",
      password: "Password",
      logging_in: "Accesso in corso…",
      login_btn: "Accedi",
      no_account: "Non hai un account?",
      to_register: "Registrati",
      register_title: "Unisciti alla community",
      register_sub: "Bastano pochi passi per iniziare ad aiutare e ricevere aiuto.",
      first_name: "Nome",
      last_name: "Cognome",
      password_hint: "Almeno 6 caratteri.",
      city: "Città di residenza",
      city_placeholder: "Es. Milano",
      accept_rules: "Accetto le regole della community: aiuto gratuito, di persona, senza compensi monetari. Niente offerte di lavoro, prestiti, vendite o raccolte fondi.",
      creating: "Creazione account…",
      create_btn: "Crea il mio account",
      have_account: "Hai già un account?",
      to_login: "Accedi",
      verify_title: "Conferma la tua email",
      verify_desc: "Abbiamo generato un token di verifica. In una versione di produzione lo riceveresti via email. Per ora puoi confermarlo direttamente qui:",
      verify_btn: "Conferma email e entra",
      verifying: "Conferma in corso…",
      verify_success_title: "Email confermata!",
      verify_success_desc: "Il tuo account è ora completamente attivo. Benvenuto/a in MABW.",
      verify_error_title: "Verifica non riuscita",
      check_email_title: "Controlla la tua email",
      check_email_desc: "Abbiamo inviato un link di conferma a {email}. Aprilo per attivare il tuo account. Puoi anche continuare ad usare MABW e verificare in seguito.",
      check_email_continue: "Continua su MABW",
      err_accept: "Devi accettare le regole della community.",
      err_pwd_short: "La password deve avere almeno 6 caratteri.",
      err_verify: "Errore durante la verifica.",
      forgot_link: "Password dimenticata?",
      forgot_title: "Recupera la tua password",
      forgot_sub: "Inserisci la tua email. Ti invieremo un link per impostare una nuova password.",
      forgot_submit: "Invia link di reset",
      forgot_sending: "Invio in corso…",
      forgot_done_title: "Controlla la tua email",
      forgot_done_desc: "Se questo indirizzo esiste su MABW, riceverai a breve un link per reimpostare la password. Il link è valido per 1 ora.",
      forgot_dev_notice: "Modalità sviluppo: la verifica email è simulata. Usa il link qui sotto per continuare:",
      forgot_dev_link: "Procedi al reset password",
      reset_title: "Imposta una nuova password",
      reset_sub: "Scegli una password sicura per il tuo account.",
      reset_new: "Nuova password",
      reset_confirm: "Conferma password",
      reset_submit: "Aggiorna password",
      reset_submitting: "Aggiornamento…",
      reset_success: "Password aggiornata! Ora puoi accedere.",
      err_pwd_mismatch: "Le due password non coincidono.",
      err_no_token: "Token mancante. Apri il link ricevuto via email.",
      back_to_login: "Torna al login",
    },
    home: {
      hello: "Ciao {name}",
      title: "Cosa vuoi fare oggi per la community?",
      sub: "Pubblica una richiesta o esplora le richieste aperte vicino a te. Ogni gesto conta.",
      new_btn: "Nuova richiesta",
      browse_btn: "Cerca aiuto",
      unverified_title: "Email non ancora verificata",
      unverified_desc: "Verifica la tua email per sbloccare tutte le funzionalità.",
      impact: "Il tuo impatto",
      completed: "Aiuti completati",
      avg_rating: "Valutazione media",
      reviews: "Recensioni ricevute",
      badges: "Badge",
      no_badges: "Ancora nessun badge.",
      explore_cat: "Esplora per categoria",
      open_requests_overline: "Richieste aperte",
      open_requests_title: "Persone che hanno bisogno di una mano",
      see_all: "Vedi tutte",
      empty: "Nessuna richiesta aperta al momento. Vuoi essere tu il primo a iniziare?",
      empty_cta: "Pubblica una richiesta",
    },
    browse: {
      overline: "Cerca aiuto",
      title: "Richieste aperte nella community",
      sub: "Filtra per categoria e città. Tutti gli aiuti sono gratuiti e di persona.",
      city_placeholder: "Filtra per città (es. Milano)",
      empty: "Nessuna richiesta corrisponde ai filtri scelti.",
    },
    post: {
      overline: "Pubblica",
      title: "Chiedi una mano alla community",
      sub: "Descrivi di cosa hai bisogno. Ricorda: aiuti gratuiti, di persona, niente compensi monetari o servizi a distanza.",
      title_label: "Titolo",
      title_placeholder: "Es. Mi serve una mano a montare uno scaffale",
      category: "Categoria",
      description: "Descrizione",
      description_placeholder: "Spiega cosa serve, quando e perché. Sii rispettoso e chiaro.",
      location: "Luogo",
      location_placeholder: "Quartiere o indirizzo generico",
      date: "Data",
      duration: "Durata stimata",
      duration_placeholder: "Es. 1 ora · mezza giornata",
      publishing: "Pubblicazione…",
      submit: "Pubblica richiesta",
      cancel: "Annulla",
    },
    detail: {
      offer_title: "Offri il tuo aiuto",
      offer_placeholder: "Scrivi un breve messaggio (opzionale)",
      sending: "Invio…",
      offer_btn: "Offri aiuto",
      offers_received: "Offerte ricevute",
      no_offers: "Nessuna offerta al momento. Le offerte appariranno qui.",
      offered_to_help: "Si è offerto/a di aiutarti.",
      accept: "Accetta",
      message: "Messaggia",
      cancel_request: "Annulla questa richiesta",
      in_progress_with: "In corso con {name}",
      coordinate: "Mettetevi d'accordo via messaggio per i dettagli.",
      open_chat: "Apri conversazione",
      mark_done: "Segna come completata",
      rate_user: "Valuta {name}",
      rating_thanks: "Grazie per il tuo contributo alla fiducia della community.",
      rating_placeholder: "Racconta com'è andata (opzionale)",
      rating_submit: "Invia valutazione",
      requested_by: "Richiesto da",
    },
    messages: {
      overline: "Messaggi",
      title: "Conversazioni",
      empty_threads: "Nessuna conversazione. Inizia offrendo aiuto su una richiesta.",
      empty_state: "Seleziona una conversazione o offri aiuto su una richiesta per iniziare a parlare.",
      input_placeholder: "Scrivi un messaggio…",
      no_messages: "Nessun messaggio. Scrivi il primo!",
      send: "Invia",
    },
    profile: {
      overline: "Membro MABW",
      joined: "iscritto/a il {date}",
      helps_given: "Aiuti dati",
      avg_rating: "Voto medio",
      badges: "Badge",
      send_message: "Invia un messaggio",
      badges_title: "Badge ottenuti",
      reviews_title: "Recensioni ricevute",
      no_reviews: "Ancora nessuna recensione.",
      my_requests: "Le mie richieste",
      no_my_requests: "Non hai ancora pubblicato richieste.",
      helping_in: "Stai aiutando in",
      no_helping: "Non stai aiutando in nessuna richiesta attiva.",
    },
    lang: {
      label: "Lingua",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
    },
    wall: {
      overline: "Muro degli aiuti",
      title: "Ogni gesto lascia un segno.",
      sub: "Una traccia anonima e pubblica degli aiuti completati nella community. Tutti i nomi sono nascosti per rispetto della privacy.",
      empty: "Ancora nessun aiuto completato. Il primo gesto potrebbe essere il tuo.",
      anonymous_help: "Un membro MABW ha aiutato un altro membro",
      in_city: "a {city}",
      on_date: "il {date}",
      stat_today: "Oggi",
      stat_week: "Ultimi 7 giorni",
      stat_total: "Totale community",
    },
    map: {
      overline: "Mappa",
      title: "Richieste vicine a te",
      sub: "Esplora le richieste aperte sulla mappa. Clicca un pin per i dettagli.",
      no_coords: "Nessuna posizione geografica disponibile per questa richiesta.",
      open_request: "Apri richiesta",
      no_results: "Nessuna richiesta aperta in zona al momento.",
    },
    admin: {
      overline: "Pannello admin",
      title: "Utenti registrati",
      sub: "Solo tu, in qualità di amministratore, puoi vedere questo elenco.",
      total: "{n} utenti totali",
      col_user: "Utente",
      col_email: "Email",
      col_city: "Città",
      col_joined: "Iscritto",
      col_helps: "Aiuti",
      col_open: "Aperte",
      col_verified: "Email verificata",
      col_role: "Ruolo",
      role_admin: "Admin",
      role_user: "Membro",
      verified_yes: "Sì",
      verified_no: "No",
      loading: "Carico la lista…",
      empty: "Nessun utente registrato.",
      forbidden: "Solo gli amministratori possono vedere questa pagina.",
      cleanup_btn: "Rimuovi utenti di test (@example.com)",
      cleanup_confirm: "Confermi la rimozione di tutti gli utenti di test e dei loro dati?",
      cleanup_done: "Rimossi: {users} utenti · {requests} richieste · {messages} messaggi",
      refresh: "Aggiorna",
      col_actions: "Azioni",
      send_email: "Invia email",
      mail_subject: "Un saluto da MABW",
      mail_body: "Ciao {name},\n\nti scrivo da MABW per ringraziarti di esserti unito alla community.\n\nA presto,\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
      compose_title: "Invia email a {name}",
      compose_from: "Mittente",
      compose_from_value: "Demetrio Campolo — info@webmabw.com",
      compose_to: "Destinatario",
      compose_subject: "Oggetto",
      compose_body: "Messaggio",
      compose_send: "Invia ora",
      compose_sending: "Invio in corso…",
      compose_cancel: "Annulla",
      compose_sent: "Email inviata a {email}",
      compose_error: "Invio non riuscito: {err}",
    },
    legal: {
      impressum: "Note legali",
      privacy: "Privacy",
    },
  },

  en: {
    common: {
      loading: "Loading…",
      back: "← Back",
      cancel: "Cancel",
      submit: "Submit",
      save: "Save",
      close: "Close",
      send: "Send",
      offers: "offers",
      reviewsShort: "reviews",
      from: "By",
    },
    nav: {
      home: "Home",
      search: "Find Help",
      new: "New Request",
      messages: "Messages",
      profile: "Profile",
      map: "Map",
      wall: "Wall of Good Deeds",
      login: "Sign in",
      register: "Join us",
      logout: "Sign out",
    },
    footer: {
      tagline: "Free help between people. No money. No expectations. Just solidarity.",
    },
    status: {
      open: "Open",
      accepted: "In progress",
      completed: "Completed",
      cancelled: "Cancelled",
    },
    categories: {
      home: { label: "Home", hint: "Groceries, assembly, moves" },
      transport: { label: "Transport", hint: "Rides and accompaniment" },
      study: { label: "Study", hint: "Tutoring, homework" },
      technology: { label: "Technology", hint: "Basic digital support" },
      pets: { label: "Pets", hint: "Care and walks" },
      elderly: { label: "Elderly Care", hint: "Company and listening" },
      gardening: { label: "Gardening", hint: "Light gardening" },
      other: { label: "Other", hint: "Everything else" },
      all: "All",
    },
    badges: {
      new_member: { name: "New Member", desc: "Welcome to the community" },
      active_member: { name: "Active Member", desc: "3+ completed helps" },
      supporter: { name: "Supporter", desc: "10+ completed helps" },
      ambassador: { name: "MABW Ambassador", desc: "25+ completed helps" },
      world_builder: { name: "Better World Builder", desc: "50+ completed helps" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "Help becomes",
      hero_title_2: "a human gesture",
      hero_title_3: " again, not a transaction.",
      hero_subtitle: "MABW connects people willing to help with people in need. Free. Voluntary. In person. No debts, no money exchanged.",
      cta_join: "Join for free",
      cta_have_account: "I already have an account",
      cta_enter_app: "Enter MABW",
      members: "Members",
      completed_helps: "Completed helps",
      open_requests: "Open requests",
      in_person_title: "In person only",
      in_person_desc: "No online services or remote consultations.",
      principles_overline: "Our principles",
      principles_title: "Five values, one direction.",
      principles: {
        free: { t: "Free", d: "Every activity is free. No financial reward." },
        voluntary: { t: "Voluntary", d: "All help is offered freely. No one is forced to accept." },
        respect: { t: "Respect", d: "Civil behavior and mutually respectful relationships." },
        trust: { t: "Trust", d: "The community grows on trust between people." },
        community: { t: "Community", d: "Every small gesture contributes to the common good." },
      },
      cat_overline: "What you can ask for or offer",
      cat_title: "Small gestures, big impact.",
      cat_sub: "Groceries, accompaniment, companionship for the elderly, digital support, tutoring. In person only.",
      badges_overline: "Community recognition",
      badges_title: "Every gesture leaves a mark.",
      cta_box_title: "Be part of a more human world.",
      cta_box_desc: "MAKE A BETTER WORLD starts with a small gesture. Join the MABW community today and show that solidarity between people is still possible.",
      cta_create: "Create your account",
      cta_login: "Sign in",
      cta_browse: "Browse requests",
      support_overline: "Support the project",
      support_title: "MABW lives thanks to people who believe in this idea.",
      support_desc: "MABW is an independent project — no ads, no fees, no profit. If you want to help keep this community alive and free, you can support development with a free donation. Every contribution, however small, helps cover hosting costs and grow MABW.",
      support_cta: "Support MABW",
      support_footer: "Support the project",
    },
    auth: {
      login_title: "Welcome back",
      login_sub: "Sign in to keep building a better world.",
      email: "Email",
      password: "Password",
      logging_in: "Signing in…",
      login_btn: "Sign in",
      no_account: "Don't have an account?",
      to_register: "Register",
      register_title: "Join the community",
      register_sub: "Just a few steps to start helping and receiving help.",
      first_name: "First name",
      last_name: "Last name",
      password_hint: "At least 6 characters.",
      city: "City of residence",
      city_placeholder: "E.g. London",
      accept_rules: "I accept the community rules: free help, in person, no monetary compensation. No job offers, loans, sales or fundraising.",
      creating: "Creating account…",
      create_btn: "Create my account",
      have_account: "Already have an account?",
      to_login: "Sign in",
      verify_title: "Confirm your email",
      verify_desc: "We generated a verification token. In a production version you'd receive it by email. For now you can confirm it directly here:",
      verify_btn: "Confirm email and enter",
      verifying: "Confirming…",
      verify_success_title: "Email confirmed!",
      verify_success_desc: "Your account is now fully active. Welcome to MABW.",
      verify_error_title: "Verification failed",
      check_email_title: "Check your email",
      check_email_desc: "We sent a confirmation link to {email}. Open it to activate your account. You can also keep using MABW and confirm later.",
      check_email_continue: "Continue to MABW",
      err_accept: "You must accept the community rules.",
      err_pwd_short: "Password must be at least 6 characters.",
      err_verify: "Error during verification.",
      forgot_link: "Forgot password?",
      forgot_title: "Recover your password",
      forgot_sub: "Enter your email. We'll send you a link to set a new password.",
      forgot_submit: "Send reset link",
      forgot_sending: "Sending…",
      forgot_done_title: "Check your email",
      forgot_done_desc: "If that address exists on MABW, you'll soon receive a password reset link. The link is valid for 1 hour.",
      forgot_dev_notice: "Development mode: email delivery is simulated. Use the link below to continue:",
      forgot_dev_link: "Continue to password reset",
      reset_title: "Set a new password",
      reset_sub: "Choose a strong password for your account.",
      reset_new: "New password",
      reset_confirm: "Confirm password",
      reset_submit: "Update password",
      reset_submitting: "Updating…",
      reset_success: "Password updated! You can now sign in.",
      err_pwd_mismatch: "The two passwords do not match.",
      err_no_token: "Missing token. Please open the link from your email.",
      back_to_login: "Back to login",
    },
    home: {
      hello: "Hi {name}",
      title: "What would you like to do for the community today?",
      sub: "Post a request or browse open requests near you. Every gesture counts.",
      new_btn: "New request",
      browse_btn: "Find help",
      unverified_title: "Email not yet verified",
      unverified_desc: "Verify your email to unlock all features.",
      impact: "Your impact",
      completed: "Completed helps",
      avg_rating: "Average rating",
      reviews: "Reviews received",
      badges: "Badges",
      no_badges: "No badges yet.",
      explore_cat: "Explore by category",
      open_requests_overline: "Open requests",
      open_requests_title: "People who need a hand",
      see_all: "See all",
      empty: "No open requests right now. Want to be the first to start?",
      empty_cta: "Post a request",
    },
    browse: {
      overline: "Find help",
      title: "Open requests in the community",
      sub: "Filter by category and city. All help is free and in person.",
      city_placeholder: "Filter by city (e.g. London)",
      empty: "No request matches the chosen filters.",
    },
    post: {
      overline: "Post",
      title: "Ask the community for a hand",
      sub: "Describe what you need. Remember: help is free, in person, no monetary compensation or remote services.",
      title_label: "Title",
      title_placeholder: "E.g. I need help assembling a shelf",
      category: "Category",
      description: "Description",
      description_placeholder: "Explain what's needed, when and why. Be respectful and clear.",
      location: "Location",
      location_placeholder: "Neighborhood or general address",
      date: "Date",
      duration: "Estimated duration",
      duration_placeholder: "E.g. 1 hour · half a day",
      publishing: "Publishing…",
      submit: "Publish request",
      cancel: "Cancel",
    },
    detail: {
      offer_title: "Offer your help",
      offer_placeholder: "Write a short message (optional)",
      sending: "Sending…",
      offer_btn: "Offer help",
      offers_received: "Offers received",
      no_offers: "No offers yet. Offers will appear here.",
      offered_to_help: "Offered to help you.",
      accept: "Accept",
      message: "Message",
      cancel_request: "Cancel this request",
      in_progress_with: "In progress with {name}",
      coordinate: "Coordinate details via direct messages.",
      open_chat: "Open conversation",
      mark_done: "Mark as completed",
      rate_user: "Rate {name}",
      rating_thanks: "Thank you for contributing to community trust.",
      rating_placeholder: "Tell how it went (optional)",
      rating_submit: "Submit rating",
      requested_by: "Requested by",
    },
    messages: {
      overline: "Messages",
      title: "Conversations",
      empty_threads: "No conversations yet. Start by offering help on a request.",
      empty_state: "Select a conversation or offer help on a request to start chatting.",
      input_placeholder: "Write a message…",
      no_messages: "No messages. Write the first one!",
      send: "Send",
    },
    profile: {
      overline: "MABW Member",
      joined: "joined on {date}",
      helps_given: "Helps given",
      avg_rating: "Avg rating",
      badges: "Badges",
      send_message: "Send a message",
      badges_title: "Badges earned",
      reviews_title: "Reviews received",
      no_reviews: "No reviews yet.",
      my_requests: "My requests",
      no_my_requests: "You haven't posted any requests yet.",
      helping_in: "You are helping in",
      no_helping: "You are not helping in any active request.",
    },
    lang: {
      label: "Language",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
    },
    wall: {
      overline: "Wall of Good Deeds",
      title: "Every gesture leaves a mark.",
      sub: "An anonymous public record of completed helps in the community. All names are hidden to respect privacy.",
      empty: "No completed helps yet. The first gesture could be yours.",
      anonymous_help: "An MABW member helped another member",
      in_city: "in {city}",
      on_date: "on {date}",
      stat_today: "Today",
      stat_week: "Last 7 days",
      stat_total: "Community total",
    },
    map: {
      overline: "Map",
      title: "Requests near you",
      sub: "Explore open requests on the map. Click a pin for details.",
      no_coords: "No geographic location available for this request.",
      open_request: "Open request",
      no_results: "No open requests in the area right now.",
    },
    admin: {
      overline: "Admin panel",
      title: "Registered users",
      sub: "Only you, as administrator, can see this list.",
      total: "{n} users total",
      col_user: "User",
      col_email: "Email",
      col_city: "City",
      col_joined: "Joined",
      col_helps: "Helps",
      col_open: "Open",
      col_verified: "Email verified",
      col_role: "Role",
      role_admin: "Admin",
      role_user: "Member",
      verified_yes: "Yes",
      verified_no: "No",
      loading: "Loading users…",
      empty: "No registered users.",
      forbidden: "Only administrators can see this page.",
      cleanup_btn: "Remove test users (@example.com)",
      cleanup_confirm: "Confirm removal of all test users and their data?",
      cleanup_done: "Removed: {users} users · {requests} requests · {messages} messages",
      refresh: "Refresh",
      col_actions: "Actions",
      send_email: "Send email",
      mail_subject: "A note from MABW",
      mail_body: "Hi {name},\n\nI'm reaching out from MABW to thank you for joining the community.\n\nBest,\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
    },
    legal: {
      impressum: "Legal notice",
      privacy: "Privacy",
    },
  },

  de: {
    common: {
      loading: "Wird geladen…",
      back: "← Zurück",
      cancel: "Abbrechen",
      submit: "Senden",
      save: "Speichern",
      close: "Schließen",
      send: "Senden",
      offers: "Angebote",
      reviewsShort: "Bewertungen",
      from: "Von",
    },
    nav: {
      home: "Startseite",
      search: "Hilfe finden",
      new: "Neue Anfrage",
      messages: "Nachrichten",
      profile: "Profil",
      map: "Karte",
      wall: "Mauer der guten Taten",
      login: "Anmelden",
      register: "Mitmachen",
      logout: "Abmelden",
    },
    footer: {
      tagline: "Kostenlose Hilfe zwischen Menschen. Kein Geld. Keine Erwartungen. Nur Solidarität.",
    },
    status: {
      open: "Offen",
      accepted: "Läuft",
      completed: "Abgeschlossen",
      cancelled: "Abgesagt",
    },
    categories: {
      home: { label: "Zuhause", hint: "Einkauf, Aufbau, Umzüge" },
      transport: { label: "Transport", hint: "Begleitung und Fahrten" },
      study: { label: "Lernen", hint: "Nachhilfe, Hausaufgaben" },
      technology: { label: "Technik", hint: "Einfache digitale Hilfe" },
      pets: { label: "Tiere", hint: "Pflege und Spaziergänge" },
      elderly: { label: "Seniorenhilfe", hint: "Gesellschaft und Zuhören" },
      gardening: { label: "Garten", hint: "Leichte Gartenarbeit" },
      other: { label: "Sonstiges", hint: "Alles andere" },
      all: "Alle",
    },
    badges: {
      new_member: { name: "Neues Mitglied", desc: "Willkommen in der Community" },
      active_member: { name: "Aktives Mitglied", desc: "3+ abgeschlossene Hilfen" },
      supporter: { name: "Unterstützer", desc: "10+ abgeschlossene Hilfen" },
      ambassador: { name: "MABW-Botschafter", desc: "25+ abgeschlossene Hilfen" },
      world_builder: { name: "Erbauer einer besseren Welt", desc: "50+ abgeschlossene Hilfen" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "Hilfe wird wieder",
      hero_title_2: "eine menschliche Geste",
      hero_title_3: ", keine Transaktion.",
      hero_subtitle: "MABW verbindet hilfsbereite Menschen mit Menschen, die Hilfe brauchen. Kostenlos. Freiwillig. Persönlich. Keine Schulden, kein Geld.",
      cta_join: "Kostenlos mitmachen",
      cta_have_account: "Ich habe schon ein Konto",
      cta_enter_app: "Zu MABW",
      members: "Mitglieder",
      completed_helps: "Abgeschlossene Hilfen",
      open_requests: "Offene Anfragen",
      in_person_title: "Nur persönlich",
      in_person_desc: "Keine Online-Dienste oder Beratungen aus der Ferne.",
      principles_overline: "Unsere Grundsätze",
      principles_title: "Fünf Werte, eine Richtung.",
      principles: {
        free: { t: "Kostenlos", d: "Jede Aktivität ist kostenlos. Keine finanzielle Belohnung." },
        voluntary: { t: "Freiwillig", d: "Jede Hilfe ist frei. Niemand muss annehmen." },
        respect: { t: "Respekt", d: "Höfliches Verhalten und gegenseitiger Respekt." },
        trust: { t: "Vertrauen", d: "Die Community lebt vom Vertrauen zwischen Menschen." },
        community: { t: "Gemeinschaft", d: "Jede kleine Geste trägt zum Gemeinwohl bei." },
      },
      cat_overline: "Was du anbieten oder erbitten kannst",
      cat_title: "Kleine Gesten, große Wirkung.",
      cat_sub: "Einkauf, Begleitung, Gesellschaft für Senioren, digitale Hilfe, Nachhilfe. Nur persönlich.",
      badges_overline: "Auszeichnungen der Community",
      badges_title: "Jede Geste hinterlässt Spuren.",
      cta_box_title: "Sei Teil einer menschlicheren Welt.",
      cta_box_desc: "MAKE A BETTER WORLD beginnt mit einer kleinen Geste. Tritt heute der MABW-Community bei und zeige, dass Solidarität zwischen Menschen noch möglich ist.",
      cta_create: "Konto erstellen",
      cta_login: "Anmelden",
      cta_browse: "Anfragen ansehen",
      support_overline: "Unterstütze das Projekt",
      support_title: "MABW lebt dank derer, die an diese Idee glauben.",
      support_desc: "MABW ist ein unabhängiges Projekt — ohne Werbung, ohne Gebühren, ohne Gewinnabsicht. Wenn du dazu beitragen möchtest, diese Community lebendig und kostenlos zu halten, kannst du die Entwicklung mit einer freien Spende unterstützen. Jeder Beitrag, auch ein kleiner, hilft, Hosting-Kosten zu decken und MABW wachsen zu lassen.",
      support_cta: "MABW unterstützen",
      support_footer: "Projekt unterstützen",
    },
    auth: {
      login_title: "Willkommen zurück",
      login_sub: "Melde dich an, um weiter eine bessere Welt aufzubauen.",
      email: "E-Mail",
      password: "Passwort",
      logging_in: "Anmelden…",
      login_btn: "Anmelden",
      no_account: "Noch kein Konto?",
      to_register: "Registrieren",
      register_title: "Tritt der Community bei",
      register_sub: "Nur wenige Schritte, um zu helfen und Hilfe zu erhalten.",
      first_name: "Vorname",
      last_name: "Nachname",
      password_hint: "Mindestens 6 Zeichen.",
      city: "Wohnort",
      city_placeholder: "z. B. Berlin",
      accept_rules: "Ich akzeptiere die Community-Regeln: kostenlose Hilfe, persönlich, ohne Geldzahlungen. Keine Jobangebote, Kredite, Verkäufe oder Spendensammlungen.",
      creating: "Konto wird erstellt…",
      create_btn: "Mein Konto erstellen",
      have_account: "Schon ein Konto?",
      to_login: "Anmelden",
      verify_title: "E-Mail bestätigen",
      verify_desc: "Wir haben ein Bestätigungs-Token erzeugt. In einer Produktionsversion erhältst du es per E-Mail. Vorläufig kannst du es direkt hier bestätigen:",
      verify_btn: "E-Mail bestätigen und eintreten",
      verifying: "Bestätigen…",
      verify_success_title: "E-Mail bestätigt!",
      verify_success_desc: "Dein Konto ist jetzt vollständig aktiv. Willkommen bei MABW.",
      verify_error_title: "Bestätigung fehlgeschlagen",
      check_email_title: "Prüfe deine E-Mails",
      check_email_desc: "Wir haben einen Bestätigungslink an {email} gesendet. Öffne ihn, um dein Konto zu aktivieren. Du kannst MABW auch weiter nutzen und später bestätigen.",
      check_email_continue: "Weiter zu MABW",
      err_accept: "Du musst die Community-Regeln akzeptieren.",
      err_pwd_short: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      err_verify: "Fehler bei der Bestätigung.",
      forgot_link: "Passwort vergessen?",
      forgot_title: "Passwort zurücksetzen",
      forgot_sub: "Gib deine E-Mail ein. Wir senden dir einen Link zum Festlegen eines neuen Passworts.",
      forgot_submit: "Reset-Link senden",
      forgot_sending: "Wird gesendet…",
      forgot_done_title: "Prüfe deine E-Mails",
      forgot_done_desc: "Falls diese Adresse bei MABW existiert, erhältst du in Kürze einen Link zum Zurücksetzen. Der Link ist 1 Stunde gültig.",
      forgot_dev_notice: "Entwicklungsmodus: E-Mail-Versand ist simuliert. Nutze den Link unten, um fortzufahren:",
      forgot_dev_link: "Weiter zum Passwort-Reset",
      reset_title: "Neues Passwort festlegen",
      reset_sub: "Wähle ein sicheres Passwort für dein Konto.",
      reset_new: "Neues Passwort",
      reset_confirm: "Passwort bestätigen",
      reset_submit: "Passwort aktualisieren",
      reset_submitting: "Wird aktualisiert…",
      reset_success: "Passwort aktualisiert! Du kannst dich jetzt anmelden.",
      err_pwd_mismatch: "Die beiden Passwörter stimmen nicht überein.",
      err_no_token: "Token fehlt. Bitte öffne den Link aus deiner E-Mail.",
      back_to_login: "Zurück zur Anmeldung",
    },
    home: {
      hello: "Hallo {name}",
      title: "Was möchtest du heute für die Community tun?",
      sub: "Stelle eine Anfrage oder entdecke offene Anfragen in deiner Nähe. Jede Geste zählt.",
      new_btn: "Neue Anfrage",
      browse_btn: "Hilfe finden",
      unverified_title: "E-Mail noch nicht bestätigt",
      unverified_desc: "Bestätige deine E-Mail, um alle Funktionen freizuschalten.",
      impact: "Dein Beitrag",
      completed: "Abgeschlossene Hilfen",
      avg_rating: "Durchschnittliche Bewertung",
      reviews: "Erhaltene Bewertungen",
      badges: "Abzeichen",
      no_badges: "Noch keine Abzeichen.",
      explore_cat: "Nach Kategorie entdecken",
      open_requests_overline: "Offene Anfragen",
      open_requests_title: "Menschen, die Hilfe brauchen",
      see_all: "Alle anzeigen",
      empty: "Aktuell keine offenen Anfragen. Möchtest du die Erste/der Erste sein?",
      empty_cta: "Anfrage stellen",
    },
    browse: {
      overline: "Hilfe finden",
      title: "Offene Anfragen in der Community",
      sub: "Filtere nach Kategorie und Stadt. Jede Hilfe ist kostenlos und persönlich.",
      city_placeholder: "Nach Stadt filtern (z. B. Berlin)",
      empty: "Keine Anfrage entspricht den gewählten Filtern.",
    },
    post: {
      overline: "Veröffentlichen",
      title: "Bitte die Community um Hilfe",
      sub: "Beschreibe, was du brauchst. Hinweis: Hilfe ist kostenlos, persönlich, ohne Geldzahlungen und ohne Ferndienste.",
      title_label: "Titel",
      title_placeholder: "z. B. Hilfe beim Aufbau eines Regals",
      category: "Kategorie",
      description: "Beschreibung",
      description_placeholder: "Erkläre, was, wann und warum nötig ist. Sei höflich und klar.",
      location: "Ort",
      location_placeholder: "Stadtteil oder allgemeine Adresse",
      date: "Datum",
      duration: "Geschätzte Dauer",
      duration_placeholder: "z. B. 1 Stunde · halber Tag",
      publishing: "Veröffentlichen…",
      submit: "Anfrage veröffentlichen",
      cancel: "Abbrechen",
    },
    detail: {
      offer_title: "Biete deine Hilfe an",
      offer_placeholder: "Schreibe eine kurze Nachricht (optional)",
      sending: "Senden…",
      offer_btn: "Hilfe anbieten",
      offers_received: "Erhaltene Angebote",
      no_offers: "Noch keine Angebote. Angebote erscheinen hier.",
      offered_to_help: "Hat angeboten, dir zu helfen.",
      accept: "Annehmen",
      message: "Nachricht",
      cancel_request: "Diese Anfrage abbrechen",
      in_progress_with: "Läuft mit {name}",
      coordinate: "Klärt die Details per Nachricht.",
      open_chat: "Unterhaltung öffnen",
      mark_done: "Als abgeschlossen markieren",
      rate_user: "{name} bewerten",
      rating_thanks: "Danke für deinen Beitrag zum Vertrauen der Community.",
      rating_placeholder: "Erzähle, wie es gelaufen ist (optional)",
      rating_submit: "Bewertung senden",
      requested_by: "Angefragt von",
    },
    messages: {
      overline: "Nachrichten",
      title: "Unterhaltungen",
      empty_threads: "Noch keine Unterhaltungen. Biete zuerst Hilfe auf einer Anfrage an.",
      empty_state: "Wähle eine Unterhaltung oder biete Hilfe auf einer Anfrage an, um zu schreiben.",
      input_placeholder: "Nachricht schreiben…",
      no_messages: "Noch keine Nachrichten. Schreibe die erste!",
      send: "Senden",
    },
    profile: {
      overline: "MABW-Mitglied",
      joined: "registriert am {date}",
      helps_given: "Geleistete Hilfen",
      avg_rating: "Durchschnittsnote",
      badges: "Abzeichen",
      send_message: "Nachricht senden",
      badges_title: "Erhaltene Abzeichen",
      reviews_title: "Erhaltene Bewertungen",
      no_reviews: "Noch keine Bewertungen.",
      my_requests: "Meine Anfragen",
      no_my_requests: "Du hast noch keine Anfragen veröffentlicht.",
      helping_in: "Du hilfst bei",
      no_helping: "Du hilfst gerade nicht bei aktiven Anfragen.",
    },
    lang: {
      label: "Sprache",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
    },
    wall: {
      overline: "Mauer der guten Taten",
      title: "Jede Geste hinterlässt Spuren.",
      sub: "Eine anonyme öffentliche Spur der abgeschlossenen Hilfen in der Community. Alle Namen sind aus Datenschutzgründen verborgen.",
      empty: "Noch keine abgeschlossenen Hilfen. Die erste Geste könnte deine sein.",
      anonymous_help: "Ein MABW-Mitglied hat einem anderen Mitglied geholfen",
      in_city: "in {city}",
      on_date: "am {date}",
      stat_today: "Heute",
      stat_week: "Letzte 7 Tage",
      stat_total: "Community insgesamt",
    },
    map: {
      overline: "Karte",
      title: "Anfragen in deiner Nähe",
      sub: "Entdecke offene Anfragen auf der Karte. Klicke auf einen Pin für Details.",
      no_coords: "Kein geografischer Standort für diese Anfrage verfügbar.",
      open_request: "Anfrage öffnen",
      no_results: "Aktuell keine offenen Anfragen in der Region.",
    },
    admin: {
      overline: "Admin-Bereich",
      title: "Registrierte Nutzer",
      sub: "Nur du als Administrator kannst diese Liste sehen.",
      total: "{n} Nutzer insgesamt",
      col_user: "Nutzer",
      col_email: "E-Mail",
      col_city: "Stadt",
      col_joined: "Beigetreten",
      col_helps: "Hilfen",
      col_open: "Offen",
      col_verified: "E-Mail bestätigt",
      col_role: "Rolle",
      role_admin: "Admin",
      role_user: "Mitglied",
      verified_yes: "Ja",
      verified_no: "Nein",
      loading: "Lade Nutzer…",
      empty: "Keine registrierten Nutzer.",
      forbidden: "Nur Administratoren können diese Seite sehen.",
      cleanup_btn: "Testnutzer entfernen (@example.com)",
      cleanup_confirm: "Bestätige die Entfernung aller Testnutzer und ihrer Daten?",
      cleanup_done: "Entfernt: {users} Nutzer · {requests} Anfragen · {messages} Nachrichten",
      refresh: "Aktualisieren",
      col_actions: "Aktionen",
      send_email: "E-Mail senden",
      mail_subject: "Ein Gruß von MABW",
      mail_body: "Hallo {name},\n\nich schreibe dir von MABW, um dir für den Beitritt zur Community zu danken.\n\nViele Grüße,\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
      compose_title: "E-Mail an {name} senden",
      compose_from: "Absender",
      compose_from_value: "Demetrio Campolo — info@webmabw.com",
      compose_to: "Empfänger",
      compose_subject: "Betreff",
      compose_body: "Nachricht",
      compose_send: "Jetzt senden",
      compose_sending: "Senden…",
      compose_cancel: "Abbrechen",
      compose_sent: "E-Mail an {email} gesendet",
      compose_error: "Senden fehlgeschlagen: {err}",
    },
    legal: {
      impressum: "Impressum",
      privacy: "Datenschutz",
    },
  },

  es: {
    common: {
      loading: "Cargando…",
      back: "← Atrás",
      cancel: "Cancelar",
      submit: "Enviar",
      save: "Guardar",
      close: "Cerrar",
      send: "Enviar",
      offers: "ofertas",
      reviewsShort: "reseñas",
      from: "De",
    },
    nav: {
      home: "Inicio",
      search: "Buscar Ayuda",
      new: "Nueva Solicitud",
      messages: "Mensajes",
      profile: "Perfil",
      map: "Mapa",
      wall: "Muro de Buenas Acciones",
      login: "Iniciar sesión",
      register: "Únete",
      logout: "Salir",
    },
    footer: {
      tagline: "Ayuda gratuita entre personas. Sin dinero. Sin expectativas. Solo solidaridad.",
    },
    status: {
      open: "Abierta",
      accepted: "En curso",
      completed: "Completada",
      cancelled: "Cancelada",
    },
    categories: {
      home: { label: "Hogar", hint: "Compras, montaje, mudanzas" },
      transport: { label: "Transporte", hint: "Acompañamiento y desplazamientos" },
      study: { label: "Estudio", hint: "Clases particulares, tareas" },
      technology: { label: "Tecnología", hint: "Apoyo digital básico" },
      pets: { label: "Mascotas", hint: "Cuidado y paseos" },
      elderly: { label: "Ayuda a Mayores", hint: "Compañía y escucha" },
      gardening: { label: "Jardinería", hint: "Jardinería ligera" },
      other: { label: "Otro", hint: "Todo lo demás" },
      all: "Todas",
    },
    badges: {
      new_member: { name: "Nuevo Miembro", desc: "Bienvenido a la comunidad" },
      active_member: { name: "Miembro Activo", desc: "3+ ayudas completadas" },
      supporter: { name: "Defensor", desc: "10+ ayudas completadas" },
      ambassador: { name: "Embajador MABW", desc: "25+ ayudas completadas" },
      world_builder: { name: "Constructor de un Mundo Mejor", desc: "50+ ayudas completadas" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "La ayuda vuelve a ser",
      hero_title_2: "un gesto humano",
      hero_title_3: ", no una transacción.",
      hero_subtitle: "MABW conecta personas dispuestas a ayudar con personas que lo necesitan. Gratis. Voluntario. En persona. Sin deudas ni dinero de por medio.",
      cta_join: "Únete gratis",
      cta_have_account: "Ya tengo una cuenta",
      cta_enter_app: "Entrar en MABW",
      members: "Miembros",
      completed_helps: "Ayudas completadas",
      open_requests: "Solicitudes abiertas",
      in_person_title: "Solo en persona",
      in_person_desc: "Sin servicios online ni consultas a distancia.",
      principles_overline: "Nuestros principios",
      principles_title: "Cinco valores, una sola dirección.",
      principles: {
        free: { t: "Gratuito", d: "Cada actividad es gratuita. Sin recompensa económica." },
        voluntary: { t: "Voluntario", d: "Toda ayuda es libre. Nadie está obligado a aceptar." },
        respect: { t: "Respeto", d: "Comportamiento civil y relaciones de respeto mutuo." },
        trust: { t: "Confianza", d: "La comunidad crece sobre la confianza entre personas." },
        community: { t: "Comunidad", d: "Cada pequeño gesto contribuye al bien común." },
      },
      cat_overline: "Lo que puedes pedir u ofrecer",
      cat_title: "Pequeños gestos, gran impacto.",
      cat_sub: "Compras, acompañamiento, compañía a mayores, apoyo digital, clases. Solo en persona.",
      badges_overline: "Reconocimientos de la comunidad",
      badges_title: "Cada gesto deja una huella.",
      cta_box_title: "Sé parte de un mundo más humano.",
      cta_box_desc: "MAKE A BETTER WORLD empieza con un pequeño gesto. Únete hoy a la comunidad MABW y demuestra que la solidaridad entre personas aún es posible.",
      cta_create: "Crea tu cuenta",
      cta_login: "Iniciar sesión",
      cta_browse: "Ver solicitudes",
      support_overline: "Apoya el proyecto",
      support_title: "MABW vive gracias a quienes creen en esta idea.",
      support_desc: "MABW es un proyecto independiente — sin publicidad, sin comisiones, sin ánimo de lucro. Si quieres ayudar a mantener viva y gratuita esta comunidad, puedes apoyar el desarrollo con una donación libre. Cada contribución, por pequeña que sea, ayuda a cubrir costes y a hacer crecer MABW.",
      support_cta: "Apoyar MABW",
      support_footer: "Apoya el proyecto",
    },
    auth: {
      login_title: "Bienvenido de nuevo",
      login_sub: "Inicia sesión para seguir construyendo un mundo mejor.",
      email: "Correo electrónico",
      password: "Contraseña",
      logging_in: "Iniciando sesión…",
      login_btn: "Iniciar sesión",
      no_account: "¿No tienes cuenta?",
      to_register: "Regístrate",
      register_title: "Únete a la comunidad",
      register_sub: "Sólo unos pasos para empezar a ayudar y recibir ayuda.",
      first_name: "Nombre",
      last_name: "Apellido",
      password_hint: "Mínimo 6 caracteres.",
      city: "Ciudad de residencia",
      city_placeholder: "Ej. Madrid",
      accept_rules: "Acepto las reglas de la comunidad: ayuda gratuita, en persona, sin compensación económica. Sin ofertas de trabajo, préstamos, ventas ni recaudaciones.",
      creating: "Creando cuenta…",
      create_btn: "Crear mi cuenta",
      have_account: "¿Ya tienes cuenta?",
      to_login: "Iniciar sesión",
      verify_title: "Confirma tu correo",
      verify_desc: "Hemos generado un token de verificación. En una versión de producción lo recibirías por correo. Por ahora puedes confirmarlo aquí:",
      verify_btn: "Confirmar correo y entrar",
      verifying: "Confirmando…",
      verify_success_title: "¡Correo confirmado!",
      verify_success_desc: "Tu cuenta está totalmente activa. Bienvenido a MABW.",
      verify_error_title: "Verificación fallida",
      check_email_title: "Revisa tu correo",
      check_email_desc: "Hemos enviado un enlace de confirmación a {email}. Ábrelo para activar tu cuenta. También puedes seguir usando MABW y confirmar más tarde.",
      check_email_continue: "Continuar en MABW",
      err_accept: "Debes aceptar las reglas de la comunidad.",
      err_pwd_short: "La contraseña debe tener al menos 6 caracteres.",
      err_verify: "Error durante la verificación.",
      forgot_link: "¿Olvidaste tu contraseña?",
      forgot_title: "Recupera tu contraseña",
      forgot_sub: "Introduce tu correo. Te enviaremos un enlace para crear una nueva contraseña.",
      forgot_submit: "Enviar enlace",
      forgot_sending: "Enviando…",
      forgot_done_title: "Revisa tu correo",
      forgot_done_desc: "Si esa dirección existe en MABW, recibirás pronto un enlace para restablecer la contraseña. Es válido durante 1 hora.",
      forgot_dev_notice: "Modo desarrollo: el envío de correo está simulado. Usa el enlace de abajo para continuar:",
      forgot_dev_link: "Ir al restablecimiento",
      reset_title: "Crea una nueva contraseña",
      reset_sub: "Elige una contraseña segura para tu cuenta.",
      reset_new: "Nueva contraseña",
      reset_confirm: "Confirma contraseña",
      reset_submit: "Actualizar contraseña",
      reset_submitting: "Actualizando…",
      reset_success: "¡Contraseña actualizada! Ya puedes iniciar sesión.",
      err_pwd_mismatch: "Las dos contraseñas no coinciden.",
      err_no_token: "Falta el token. Abre el enlace recibido por correo.",
      back_to_login: "Volver al inicio de sesión",
    },
    home: {
      hello: "Hola {name}",
      title: "¿Qué quieres hacer hoy por la comunidad?",
      sub: "Publica una solicitud o explora las abiertas cerca de ti. Cada gesto cuenta.",
      new_btn: "Nueva solicitud",
      browse_btn: "Buscar ayuda",
      unverified_title: "Correo aún no verificado",
      unverified_desc: "Verifica tu correo para desbloquear todas las funciones.",
      impact: "Tu impacto",
      completed: "Ayudas completadas",
      avg_rating: "Valoración media",
      reviews: "Reseñas recibidas",
      badges: "Insignias",
      no_badges: "Aún sin insignias.",
      explore_cat: "Explorar por categoría",
      open_requests_overline: "Solicitudes abiertas",
      open_requests_title: "Personas que necesitan una mano",
      see_all: "Ver todas",
      empty: "No hay solicitudes abiertas. ¿Quieres ser el primero?",
      empty_cta: "Publicar una solicitud",
    },
    browse: {
      overline: "Buscar ayuda",
      title: "Solicitudes abiertas en la comunidad",
      sub: "Filtra por categoría y ciudad. Todas las ayudas son gratuitas y en persona.",
      city_placeholder: "Filtrar por ciudad (ej. Madrid)",
      empty: "Ninguna solicitud coincide con los filtros elegidos.",
    },
    post: {
      overline: "Publicar",
      title: "Pide ayuda a la comunidad",
      sub: "Describe lo que necesitas. Recuerda: ayuda gratuita, en persona, sin compensación ni servicios a distancia.",
      title_label: "Título",
      title_placeholder: "Ej. Necesito ayuda para montar una estantería",
      category: "Categoría",
      description: "Descripción",
      description_placeholder: "Explica qué, cuándo y por qué. Sé claro y respetuoso.",
      location: "Lugar",
      location_placeholder: "Barrio o dirección general",
      date: "Fecha",
      duration: "Duración estimada",
      duration_placeholder: "Ej. 1 hora · medio día",
      publishing: "Publicando…",
      submit: "Publicar solicitud",
      cancel: "Cancelar",
    },
    detail: {
      offer_title: "Ofrece tu ayuda",
      offer_placeholder: "Escribe un mensaje breve (opcional)",
      sending: "Enviando…",
      offer_btn: "Ofrecer ayuda",
      offers_received: "Ofertas recibidas",
      no_offers: "Aún sin ofertas. Aparecerán aquí.",
      offered_to_help: "Se ha ofrecido a ayudarte.",
      accept: "Aceptar",
      message: "Mensaje",
      cancel_request: "Cancelar esta solicitud",
      in_progress_with: "En curso con {name}",
      coordinate: "Coordinad los detalles por mensaje.",
      open_chat: "Abrir conversación",
      mark_done: "Marcar como completada",
      rate_user: "Valorar a {name}",
      rating_thanks: "Gracias por tu contribución a la confianza de la comunidad.",
      rating_placeholder: "Cuenta cómo fue (opcional)",
      rating_submit: "Enviar valoración",
      requested_by: "Solicitado por",
    },
    messages: {
      overline: "Mensajes",
      title: "Conversaciones",
      empty_threads: "Sin conversaciones. Empieza ofreciendo ayuda en una solicitud.",
      empty_state: "Selecciona una conversación o ofrece ayuda para empezar a hablar.",
      input_placeholder: "Escribe un mensaje…",
      no_messages: "Sin mensajes. ¡Escribe el primero!",
      send: "Enviar",
    },
    profile: {
      overline: "Miembro MABW",
      joined: "se unió el {date}",
      helps_given: "Ayudas dadas",
      avg_rating: "Nota media",
      badges: "Insignias",
      send_message: "Enviar un mensaje",
      badges_title: "Insignias obtenidas",
      reviews_title: "Reseñas recibidas",
      no_reviews: "Aún sin reseñas.",
      my_requests: "Mis solicitudes",
      no_my_requests: "Aún no has publicado solicitudes.",
      helping_in: "Estás ayudando en",
      no_helping: "No estás ayudando en ninguna solicitud activa.",
    },
    lang: {
      label: "Idioma",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
    },
    wall: {
      overline: "Muro de Buenas Acciones",
      title: "Cada gesto deja una huella.",
      sub: "Un registro público y anónimo de las ayudas completadas en la comunidad. Todos los nombres están ocultos por respeto a la privacidad.",
      empty: "Aún no hay ayudas completadas. El primer gesto podría ser tuyo.",
      anonymous_help: "Un miembro de MABW ayudó a otro miembro",
      in_city: "en {city}",
      on_date: "el {date}",
      stat_today: "Hoy",
      stat_week: "Últimos 7 días",
      stat_total: "Total comunidad",
    },
    map: {
      overline: "Mapa",
      title: "Solicitudes cerca de ti",
      sub: "Explora las solicitudes abiertas en el mapa. Haz clic en un pin para ver detalles.",
      no_coords: "No hay ubicación geográfica disponible para esta solicitud.",
      open_request: "Abrir solicitud",
      no_results: "Ninguna solicitud abierta en la zona en este momento.",
    },
    admin: {
      overline: "Panel admin",
      title: "Usuarios registrados",
      sub: "Solo tú, como administrador, puedes ver esta lista.",
      total: "{n} usuarios en total",
      col_user: "Usuario",
      col_email: "Email",
      col_city: "Ciudad",
      col_joined: "Registrado",
      col_helps: "Ayudas",
      col_open: "Abiertas",
      col_verified: "Email verificado",
      col_role: "Rol",
      role_admin: "Admin",
      role_user: "Miembro",
      verified_yes: "Sí",
      verified_no: "No",
      loading: "Cargando usuarios…",
      empty: "Ningún usuario registrado.",
      forbidden: "Solo los administradores pueden ver esta página.",
      cleanup_btn: "Eliminar usuarios de prueba (@example.com)",
      cleanup_confirm: "¿Confirmas la eliminación de todos los usuarios de prueba y sus datos?",
      cleanup_done: "Eliminados: {users} usuarios · {requests} solicitudes · {messages} mensajes",
      refresh: "Actualizar",
      col_actions: "Acciones",
      send_email: "Enviar email",
      mail_subject: "Un saludo de MABW",
      mail_body: "Hola {name},\n\nte escribo desde MABW para agradecerte que te hayas unido a la comunidad.\n\nUn abrazo,\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
      compose_title: "Enviar email a {name}",
      compose_from: "Remitente",
      compose_from_value: "Demetrio Campolo — info@webmabw.com",
      compose_to: "Destinatario",
      compose_subject: "Asunto",
      compose_body: "Mensaje",
      compose_send: "Enviar ahora",
      compose_sending: "Enviando…",
      compose_cancel: "Cancelar",
      compose_sent: "Email enviado a {email}",
      compose_error: "Envío fallido: {err}",
    },
    legal: {
      impressum: "Aviso legal",
      privacy: "Privacidad",
    },
  },

  fr: {
    common: {
      loading: "Chargement…",
      back: "← Retour",
      cancel: "Annuler",
      submit: "Envoyer",
      save: "Enregistrer",
      close: "Fermer",
      send: "Envoyer",
      offers: "offres",
      reviewsShort: "avis",
      from: "Par",
    },
    nav: {
      home: "Accueil",
      search: "Chercher de l'aide",
      new: "Nouvelle demande",
      messages: "Messages",
      profile: "Profil",
      map: "Carte",
      wall: "Mur des bonnes actions",
      login: "Se connecter",
      register: "Rejoindre",
      logout: "Se déconnecter",
    },
    footer: {
      tagline: "Entraide gratuite entre personnes. Sans argent. Sans attentes. Juste de la solidarité.",
    },
    status: {
      open: "Ouverte",
      accepted: "En cours",
      completed: "Terminée",
      cancelled: "Annulée",
    },
    categories: {
      home: { label: "Maison", hint: "Courses, montage, déménagements" },
      transport: { label: "Transport", hint: "Accompagnement et déplacements" },
      study: { label: "Études", hint: "Cours particuliers, devoirs" },
      technology: { label: "Technologie", hint: "Aide numérique de base" },
      pets: { label: "Animaux", hint: "Soins et promenades" },
      elderly: { label: "Aide aux aînés", hint: "Compagnie et écoute" },
      gardening: { label: "Jardinage", hint: "Jardinage léger" },
      other: { label: "Autre", hint: "Tout le reste" },
      all: "Toutes",
    },
    badges: {
      new_member: { name: "Nouveau membre", desc: "Bienvenue dans la communauté" },
      active_member: { name: "Membre actif", desc: "3+ aides accomplies" },
      supporter: { name: "Soutien", desc: "10+ aides accomplies" },
      ambassador: { name: "Ambassadeur MABW", desc: "25+ aides accomplies" },
      world_builder: { name: "Bâtisseur d'un monde meilleur", desc: "50+ aides accomplies" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "L'aide redevient",
      hero_title_2: "un geste humain",
      hero_title_3: ", pas une transaction.",
      hero_subtitle: "MABW relie les personnes prêtes à aider à celles qui en ont besoin. Gratuit. Volontaire. En personne. Sans dette ni échange d'argent.",
      cta_join: "Rejoindre gratuitement",
      cta_have_account: "J'ai déjà un compte",
      cta_enter_app: "Entrer dans MABW",
      members: "Membres",
      completed_helps: "Aides accomplies",
      open_requests: "Demandes ouvertes",
      in_person_title: "Uniquement en personne",
      in_person_desc: "Pas de services en ligne ni de consultations à distance.",
      principles_overline: "Nos principes",
      principles_title: "Cinq valeurs, une seule direction.",
      principles: {
        free: { t: "Gratuit", d: "Chaque activité est gratuite. Aucune récompense financière." },
        voluntary: { t: "Volontaire", d: "Toute aide est libre. Personne n'est obligé d'accepter." },
        respect: { t: "Respect", d: "Un comportement civil et des relations de respect mutuel." },
        trust: { t: "Confiance", d: "La communauté grandit sur la confiance entre les personnes." },
        community: { t: "Communauté", d: "Chaque petit geste contribue au bien commun." },
      },
      cat_overline: "Ce que tu peux demander ou offrir",
      cat_title: "Petits gestes, grand impact.",
      cat_sub: "Courses, accompagnement, compagnie aux personnes âgées, aide numérique, cours particuliers. Uniquement en personne.",
      badges_overline: "Reconnaissances de la communauté",
      badges_title: "Chaque geste laisse une trace.",
      cta_box_title: "Fais partie d'un monde plus humain.",
      cta_box_desc: "MAKE A BETTER WORLD commence par un petit geste. Rejoins aujourd'hui la communauté MABW et montre que la solidarité entre personnes est encore possible.",
      cta_create: "Crée ton compte",
      cta_login: "Se connecter",
      cta_browse: "Voir les demandes",
      support_overline: "Soutenir le projet",
      support_title: "MABW vit grâce à celles et ceux qui croient à cette idée.",
      support_desc: "MABW est un projet indépendant, sans publicité, sans commissions et sans but lucratif. Si tu veux contribuer à maintenir vivante et gratuite cette communauté, tu peux soutenir le développement par un don libre. Chaque contribution, même modeste, aide à couvrir les frais d'hébergement et à faire grandir MABW.",
      support_cta: "Soutenir MABW",
      support_footer: "Soutenir le projet",
    },
    auth: {
      login_title: "Bon retour",
      login_sub: "Connecte-toi pour continuer à construire un monde meilleur.",
      email: "Email",
      password: "Mot de passe",
      logging_in: "Connexion en cours…",
      login_btn: "Se connecter",
      no_account: "Pas encore de compte ?",
      to_register: "S'inscrire",
      register_title: "Rejoins la communauté",
      register_sub: "Quelques étapes suffisent pour commencer à aider et recevoir de l'aide.",
      first_name: "Prénom",
      last_name: "Nom",
      password_hint: "Au moins 6 caractères.",
      city: "Ville de résidence",
      city_placeholder: "Ex. Paris",
      accept_rules: "J'accepte les règles de la communauté : aide gratuite, en personne, sans compensation financière. Aucune offre d'emploi, prêt, vente ou collecte de fonds.",
      creating: "Création du compte…",
      create_btn: "Créer mon compte",
      have_account: "Tu as déjà un compte ?",
      to_login: "Se connecter",
      verify_title: "Confirme ton email",
      verify_desc: "Nous avons généré un jeton de vérification. En production tu le recevrais par email. Pour l'instant, tu peux confirmer directement ici :",
      verify_btn: "Confirmer l'email et entrer",
      verifying: "Vérification…",
      verify_success_title: "Email confirmée !",
      verify_success_desc: "Ton compte est maintenant pleinement actif. Bienvenue sur MABW.",
      verify_error_title: "Échec de la vérification",
      check_email_title: "Vérifie ta boîte email",
      check_email_desc: "Nous avons envoyé un lien de confirmation à {email}. Ouvre-le pour activer ton compte. Tu peux aussi continuer à utiliser MABW et confirmer plus tard.",
      check_email_continue: "Continuer sur MABW",
      err_accept: "Tu dois accepter les règles de la communauté.",
      err_pwd_short: "Le mot de passe doit avoir au moins 6 caractères.",
      err_verify: "Erreur lors de la vérification.",
      forgot_link: "Mot de passe oublié ?",
      forgot_title: "Récupère ton mot de passe",
      forgot_sub: "Entre ton email. Nous t'enverrons un lien pour créer un nouveau mot de passe.",
      forgot_submit: "Envoyer le lien",
      forgot_sending: "Envoi…",
      forgot_done_title: "Vérifie ta boîte email",
      forgot_done_desc: "Si cette adresse existe sur MABW, tu recevras bientôt un lien pour réinitialiser ton mot de passe. Il est valable 1 heure.",
      forgot_dev_notice: "Mode développement : l'envoi d'email est simulé. Utilise le lien ci-dessous pour continuer :",
      forgot_dev_link: "Accéder à la réinitialisation",
      reset_title: "Crée un nouveau mot de passe",
      reset_sub: "Choisis un mot de passe sûr pour ton compte.",
      reset_new: "Nouveau mot de passe",
      reset_confirm: "Confirme le mot de passe",
      reset_submit: "Mettre à jour le mot de passe",
      reset_submitting: "Mise à jour…",
      reset_success: "Mot de passe mis à jour ! Tu peux maintenant te connecter.",
      err_pwd_mismatch: "Les deux mots de passe ne coïncident pas.",
      err_no_token: "Jeton manquant. Ouvre le lien reçu par email.",
      back_to_login: "Retour à la connexion",
    },
    home: {
      hello: "Bonjour {name}",
      title: "Que veux-tu faire aujourd'hui pour la communauté ?",
      sub: "Publie une demande ou explore celles ouvertes près de chez toi. Chaque geste compte.",
      new_btn: "Nouvelle demande",
      browse_btn: "Chercher de l'aide",
      unverified_title: "Email pas encore vérifiée",
      unverified_desc: "Vérifie ton email pour débloquer toutes les fonctionnalités.",
      impact: "Ton impact",
      completed: "Aides accomplies",
      avg_rating: "Note moyenne",
      reviews: "Avis reçus",
      badges: "Badges",
      no_badges: "Pas encore de badge.",
      explore_cat: "Explorer par catégorie",
      open_requests_overline: "Demandes ouvertes",
      open_requests_title: "Des personnes qui ont besoin d'un coup de main",
      see_all: "Voir toutes",
      empty: "Aucune demande ouverte pour le moment. Veux-tu être le premier ?",
      empty_cta: "Publier une demande",
    },
    browse: {
      overline: "Chercher de l'aide",
      title: "Demandes ouvertes dans la communauté",
      sub: "Filtre par catégorie et ville. Toutes les aides sont gratuites et en personne.",
      city_placeholder: "Filtrer par ville (ex. Paris)",
      empty: "Aucune demande ne correspond aux filtres choisis.",
    },
    post: {
      overline: "Publier",
      title: "Demande un coup de main à la communauté",
      sub: "Décris ce dont tu as besoin. Rappelle-toi : aide gratuite, en personne, sans compensation ni services à distance.",
      title_label: "Titre",
      title_placeholder: "Ex. J'ai besoin d'aide pour monter une étagère",
      category: "Catégorie",
      description: "Description",
      description_placeholder: "Explique quoi, quand et pourquoi. Sois clair et respectueux.",
      location: "Lieu",
      location_placeholder: "Quartier ou adresse générale",
      date: "Date",
      duration: "Durée estimée",
      duration_placeholder: "Ex. 1 heure · demi-journée",
      publishing: "Publication…",
      submit: "Publier la demande",
      cancel: "Annuler",
    },
    detail: {
      offer_title: "Offre ton aide",
      offer_placeholder: "Écris un court message (facultatif)",
      sending: "Envoi…",
      offer_btn: "Offrir mon aide",
      offers_received: "Offres reçues",
      no_offers: "Aucune offre pour l'instant. Elles apparaîtront ici.",
      offered_to_help: "S'est proposé/e de t'aider.",
      accept: "Accepter",
      message: "Message",
      cancel_request: "Annuler cette demande",
      in_progress_with: "En cours avec {name}",
      coordinate: "Mettez-vous d'accord sur les détails par message.",
      open_chat: "Ouvrir la conversation",
      mark_done: "Marquer comme terminée",
      rate_user: "Évaluer {name}",
      rating_thanks: "Merci pour ta contribution à la confiance de la communauté.",
      rating_placeholder: "Raconte comment ça s'est passé (facultatif)",
      rating_submit: "Envoyer l'évaluation",
      requested_by: "Demandé par",
    },
    messages: {
      overline: "Messages",
      title: "Conversations",
      empty_threads: "Aucune conversation. Commence en offrant ton aide sur une demande.",
      empty_state: "Sélectionne une conversation ou offre ton aide pour commencer à parler.",
      input_placeholder: "Écris un message…",
      no_messages: "Aucun message. Écris le premier !",
      send: "Envoyer",
    },
    profile: {
      overline: "Membre MABW",
      joined: "inscrit/e le {date}",
      helps_given: "Aides données",
      avg_rating: "Note moyenne",
      badges: "Badges",
      send_message: "Envoyer un message",
      badges_title: "Badges obtenus",
      reviews_title: "Avis reçus",
      no_reviews: "Encore aucun avis.",
      my_requests: "Mes demandes",
      no_my_requests: "Tu n'as pas encore publié de demandes.",
      helping_in: "Tu aides sur",
      no_helping: "Tu n'aides sur aucune demande active.",
    },
    lang: {
      label: "Langue",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
      fr: "Français",
      ja: "日本語",
    },
    wall: {
      overline: "Mur des bonnes actions",
      title: "Chaque geste laisse une trace.",
      sub: "Une trace publique et anonyme des aides accomplies dans la communauté. Tous les noms sont masqués par respect de la vie privée.",
      empty: "Encore aucune aide accomplie. Le premier geste pourrait être le tien.",
      anonymous_help: "Un membre MABW a aidé un autre membre",
      in_city: "à {city}",
      on_date: "le {date}",
      stat_today: "Aujourd'hui",
      stat_week: "7 derniers jours",
      stat_total: "Total communauté",
    },
    map: {
      overline: "Carte",
      title: "Demandes proches de toi",
      sub: "Explore les demandes ouvertes sur la carte. Clique sur un point pour les détails.",
      no_coords: "Pas de position géographique disponible pour cette demande.",
      open_request: "Ouvrir la demande",
      no_results: "Aucune demande ouverte dans la zone pour l'instant.",
    },
    admin: {
      overline: "Panneau admin",
      title: "Utilisateurs inscrits",
      sub: "Toi seul, en tant qu'administrateur, peux voir cette liste.",
      total: "{n} utilisateurs au total",
      col_user: "Utilisateur",
      col_email: "Email",
      col_city: "Ville",
      col_joined: "Inscrit le",
      col_helps: "Aides",
      col_open: "Ouvertes",
      col_verified: "Email vérifiée",
      col_role: "Rôle",
      role_admin: "Admin",
      role_user: "Membre",
      verified_yes: "Oui",
      verified_no: "Non",
      loading: "Chargement de la liste…",
      empty: "Aucun utilisateur inscrit.",
      forbidden: "Seuls les administrateurs peuvent voir cette page.",
      cleanup_btn: "Supprimer les utilisateurs de test (@example.com)",
      cleanup_confirm: "Confirmes-tu la suppression de tous les utilisateurs de test et de leurs données ?",
      cleanup_done: "Supprimés : {users} utilisateurs · {requests} demandes · {messages} messages",
      refresh: "Rafraîchir",
      col_actions: "Actions",
      send_email: "Envoyer un email",
      mail_subject: "Un bonjour de MABW",
      mail_body: "Bonjour {name},\n\nje t'écris de MABW pour te remercier d'avoir rejoint la communauté.\n\nÀ bientôt,\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
      compose_title: "Envoyer un email à {name}",
      compose_from: "Expéditeur",
      compose_from_value: "Demetrio Campolo — info@webmabw.com",
      compose_to: "Destinataire",
      compose_subject: "Objet",
      compose_body: "Message",
      compose_send: "Envoyer maintenant",
      compose_sending: "Envoi…",
      compose_cancel: "Annuler",
      compose_sent: "Email envoyé à {email}",
      compose_error: "Envoi échoué : {err}",
    },
    legal: {
      impressum: "Mentions légales",
      privacy: "Confidentialité",
    },
  },

  ja: {
    common: {
      loading: "読み込み中…",
      back: "← 戻る",
      cancel: "キャンセル",
      submit: "送信",
      save: "保存",
      close: "閉じる",
      send: "送信",
      offers: "件のオファー",
      reviewsShort: "件のレビュー",
      from: "投稿者",
    },
    nav: {
      home: "ホーム",
      search: "助けを探す",
      new: "新しい依頼",
      messages: "メッセージ",
      profile: "プロフィール",
      map: "マップ",
      wall: "善意の壁",
      login: "ログイン",
      register: "参加する",
      logout: "ログアウト",
    },
    footer: {
      tagline: "人と人との無償の助け合い。お金なし、見返りなし、あるのは連帯だけ。",
    },
    status: {
      open: "受付中",
      accepted: "進行中",
      completed: "完了",
      cancelled: "キャンセル済み",
    },
    categories: {
      home: { label: "家事", hint: "買い物、組み立て、引っ越し" },
      transport: { label: "移動", hint: "付き添いや送迎" },
      study: { label: "学習", hint: "家庭教師、宿題のサポート" },
      technology: { label: "テクノロジー", hint: "基本的なデジタル支援" },
      pets: { label: "ペット", hint: "世話や散歩" },
      elderly: { label: "高齢者支援", hint: "話し相手、傾聴" },
      gardening: { label: "ガーデニング", hint: "軽いお庭仕事" },
      other: { label: "その他", hint: "上記以外のすべて" },
      all: "すべて",
    },
    badges: {
      new_member: { name: "新メンバー", desc: "コミュニティへようこそ" },
      active_member: { name: "アクティブメンバー", desc: "3件以上の助け合い達成" },
      supporter: { name: "サポーター", desc: "10件以上の助け合い達成" },
      ambassador: { name: "MABWアンバサダー", desc: "25件以上の助け合い達成" },
      world_builder: { name: "より良い世界の作り手", desc: "50件以上の助け合い達成" },
    },
    landing: {
      overline: "MABW · Make A Better World",
      hero_title_1: "助けは再び",
      hero_title_2: "人としての行為",
      hero_title_3: "であり、取引ではありません。",
      hero_subtitle: "MABWは、助けたい人と助けを必要とする人を結びます。無料。自発的。対面で。借りも金銭のやり取りもありません。",
      cta_join: "無料で参加する",
      cta_have_account: "すでにアカウントをお持ちです",
      cta_enter_app: "MABWに入る",
      members: "メンバー",
      completed_helps: "完了した助け合い",
      open_requests: "受付中の依頼",
      in_person_title: "対面のみ",
      in_person_desc: "オンラインサービスや遠隔相談は行いません。",
      principles_overline: "私たちの原則",
      principles_title: "五つの価値、ひとつの方向。",
      principles: {
        free: { t: "無料", d: "すべての活動は無料。金銭的な報酬はありません。" },
        voluntary: { t: "自発的", d: "助けはすべて自由意思。誰も強制されません。" },
        respect: { t: "尊重", d: "礼儀正しい態度と相互尊重の関係を大切に。" },
        trust: { t: "信頼", d: "コミュニティは人と人との信頼の上に育ちます。" },
        community: { t: "コミュニティ", d: "小さな行為のひとつひとつが共通の善に貢献します。" },
      },
      cat_overline: "頼めること、提供できること",
      cat_title: "小さな行為、大きな影響。",
      cat_sub: "買い物、付き添い、高齢者の話し相手、デジタル支援、家庭教師。すべて対面で。",
      badges_overline: "コミュニティからの称賛",
      badges_title: "どの行為も足跡を残します。",
      cta_box_title: "もっと人間らしい世界の一員になろう。",
      cta_box_desc: "MAKE A BETTER WORLD は小さな行為から始まります。今日MABWコミュニティに参加し、人と人との連帯がまだ可能であることを示してください。",
      cta_create: "アカウントを作成",
      cta_login: "ログイン",
      cta_browse: "依頼を見る",
      support_overline: "プロジェクトを支援する",
      support_title: "MABWは、この理念を信じる人たちのおかげで生きています。",
      support_desc: "MABWは独立プロジェクトです。広告なし、手数料なし、非営利。このコミュニティを無料で維持し続けるために、自由な寄付で開発を支援できます。どんな小さな貢献も、ホスティング費用の負担軽減とMABWの成長に役立ちます。",
      support_cta: "MABWを支援する",
      support_footer: "プロジェクトを支援する",
    },
    auth: {
      login_title: "おかえりなさい",
      login_sub: "ログインして、より良い世界づくりを続けましょう。",
      email: "メールアドレス",
      password: "パスワード",
      logging_in: "ログイン中…",
      login_btn: "ログイン",
      no_account: "アカウントをお持ちでないですか？",
      to_register: "登録する",
      register_title: "コミュニティに参加",
      register_sub: "数ステップで、助けの提供と受け取りを始められます。",
      first_name: "名",
      last_name: "姓",
      password_hint: "6文字以上。",
      city: "居住都市",
      city_placeholder: "例：東京",
      accept_rules: "コミュニティのルールに同意します：無料で対面の助け合い、金銭的報酬なし。求人、貸付、販売、資金集めは行いません。",
      creating: "アカウント作成中…",
      create_btn: "アカウントを作成",
      have_account: "すでにアカウントをお持ちですか？",
      to_login: "ログイン",
      verify_title: "メールアドレスを確認",
      verify_desc: "確認トークンを生成しました。本番環境ではメールで届きます。ここで直接確認することもできます：",
      verify_btn: "メールを確認して入る",
      verifying: "確認中…",
      verify_success_title: "メール確認完了！",
      verify_success_desc: "アカウントが完全に有効化されました。MABWへようこそ。",
      verify_error_title: "確認に失敗しました",
      check_email_title: "メールをご確認ください",
      check_email_desc: "{email} に確認リンクを送信しました。開いてアカウントを有効化してください。MABWの利用を続けて、後で確認することもできます。",
      check_email_continue: "MABWを続ける",
      err_accept: "コミュニティのルールへの同意が必要です。",
      err_pwd_short: "パスワードは6文字以上である必要があります。",
      err_verify: "確認中にエラーが発生しました。",
      forgot_link: "パスワードをお忘れですか？",
      forgot_title: "パスワードの再設定",
      forgot_sub: "メールアドレスを入力してください。新しいパスワード設定のリンクをお送りします。",
      forgot_submit: "リンクを送信",
      forgot_sending: "送信中…",
      forgot_done_title: "メールをご確認ください",
      forgot_done_desc: "そのアドレスがMABWに登録されていれば、まもなくパスワード再設定のリンクが届きます。有効期限は1時間です。",
      forgot_dev_notice: "開発モード：メール送信はシミュレーションです。以下のリンクから続行してください：",
      forgot_dev_link: "再設定へ進む",
      reset_title: "新しいパスワードを設定",
      reset_sub: "アカウントに安全なパスワードを選んでください。",
      reset_new: "新しいパスワード",
      reset_confirm: "パスワードの確認",
      reset_submit: "パスワードを更新",
      reset_submitting: "更新中…",
      reset_success: "パスワードを更新しました！ログインできます。",
      err_pwd_mismatch: "パスワードが一致しません。",
      err_no_token: "トークンがありません。メールで受け取ったリンクを開いてください。",
      back_to_login: "ログインに戻る",
    },
    home: {
      hello: "こんにちは、{name}さん",
      title: "今日はコミュニティに何をしますか？",
      sub: "依頼を投稿するか、近くの受付中の依頼を見てみましょう。どんな行為も大切です。",
      new_btn: "新しい依頼",
      browse_btn: "助けを探す",
      unverified_title: "メール未確認",
      unverified_desc: "メールを確認するとすべての機能が使えます。",
      impact: "あなたの影響",
      completed: "完了した助け合い",
      avg_rating: "平均評価",
      reviews: "受け取ったレビュー",
      badges: "バッジ",
      no_badges: "まだバッジがありません。",
      explore_cat: "カテゴリーで探す",
      open_requests_overline: "受付中の依頼",
      open_requests_title: "手を貸してほしい人たち",
      see_all: "すべて表示",
      empty: "現在、受付中の依頼はありません。最初の一歩を踏み出しませんか？",
      empty_cta: "依頼を投稿する",
    },
    browse: {
      overline: "助けを探す",
      title: "コミュニティで受付中の依頼",
      sub: "カテゴリーと都市でフィルターできます。すべての助け合いは無料・対面です。",
      city_placeholder: "都市でフィルター（例：東京）",
      empty: "選んだ条件に合う依頼はありません。",
    },
    post: {
      overline: "投稿",
      title: "コミュニティに助けを求める",
      sub: "必要なことを説明してください。原則：無料・対面・金銭的報酬なし・遠隔サービスなし。",
      title_label: "タイトル",
      title_placeholder: "例：本棚の組み立てを手伝ってほしい",
      category: "カテゴリー",
      description: "説明",
      description_placeholder: "何を、いつ、なぜ必要かを説明してください。明確で丁寧に。",
      location: "場所",
      location_placeholder: "地区または大まかな住所",
      date: "日付",
      duration: "予想所要時間",
      duration_placeholder: "例：1時間・半日",
      publishing: "投稿中…",
      submit: "依頼を投稿",
      cancel: "キャンセル",
    },
    detail: {
      offer_title: "助けを申し出る",
      offer_placeholder: "短いメッセージを書く（任意）",
      sending: "送信中…",
      offer_btn: "助けを申し出る",
      offers_received: "受け取ったオファー",
      no_offers: "まだオファーはありません。ここに表示されます。",
      offered_to_help: "助けを申し出ています。",
      accept: "承諾する",
      message: "メッセージ",
      cancel_request: "この依頼をキャンセル",
      in_progress_with: "{name}さんと進行中",
      coordinate: "詳細はメッセージで調整してください。",
      open_chat: "会話を開く",
      mark_done: "完了としてマーク",
      rate_user: "{name}さんを評価",
      rating_thanks: "コミュニティの信頼にご協力ありがとうございます。",
      rating_placeholder: "感想を書く（任意）",
      rating_submit: "評価を送信",
      requested_by: "依頼者",
    },
    messages: {
      overline: "メッセージ",
      title: "会話",
      empty_threads: "会話はまだありません。依頼に助けを申し出て始めましょう。",
      empty_state: "会話を選ぶか、依頼に助けを申し出て話を始めましょう。",
      input_placeholder: "メッセージを書く…",
      no_messages: "メッセージはまだありません。最初の一通を！",
      send: "送信",
    },
    profile: {
      overline: "MABWメンバー",
      joined: "{date}に登録",
      helps_given: "提供した助け",
      avg_rating: "平均評価",
      badges: "バッジ",
      send_message: "メッセージを送る",
      badges_title: "獲得したバッジ",
      reviews_title: "受け取ったレビュー",
      no_reviews: "まだレビューはありません。",
      my_requests: "自分の依頼",
      no_my_requests: "まだ依頼を投稿していません。",
      helping_in: "現在お手伝い中",
      no_helping: "現在お手伝いしている依頼はありません。",
    },
    lang: {
      label: "言語",
      it: "Italiano",
      en: "English",
      de: "Deutsch",
      es: "Español",
      fr: "Français",
      ja: "日本語",
    },
    wall: {
      overline: "善意の壁",
      title: "どの行為も足跡を残す。",
      sub: "コミュニティで完了した助け合いの匿名の公開記録です。プライバシー保護のためすべての名前は非表示です。",
      empty: "まだ完了した助け合いはありません。最初の一歩はあなたのものになるかもしれません。",
      anonymous_help: "MABWのメンバーが別のメンバーを助けました",
      in_city: "{city}で",
      on_date: "{date}に",
      stat_today: "今日",
      stat_week: "過去7日間",
      stat_total: "コミュニティ全体",
    },
    map: {
      overline: "マップ",
      title: "近くの依頼",
      sub: "地図上で受付中の依頼を探しましょう。ピンをクリックすると詳細が表示されます。",
      no_coords: "この依頼には地理的位置情報がありません。",
      open_request: "依頼を開く",
      no_results: "現在、この地域に受付中の依頼はありません。",
    },
    admin: {
      overline: "管理者パネル",
      title: "登録ユーザー",
      sub: "管理者であるあなただけがこの一覧を見ることができます。",
      total: "合計 {n} 人のユーザー",
      col_user: "ユーザー",
      col_email: "メール",
      col_city: "都市",
      col_joined: "登録日",
      col_helps: "助け",
      col_open: "受付中",
      col_verified: "メール確認済み",
      col_role: "役割",
      role_admin: "管理者",
      role_user: "メンバー",
      verified_yes: "はい",
      verified_no: "いいえ",
      loading: "一覧を読み込み中…",
      empty: "登録ユーザーがいません。",
      forbidden: "このページは管理者のみ閲覧できます。",
      cleanup_btn: "テストユーザーを削除（@example.com）",
      cleanup_confirm: "すべてのテストユーザーとそのデータの削除を確認しますか？",
      cleanup_done: "削除済み：ユーザー{users}件・依頼{requests}件・メッセージ{messages}件",
      refresh: "更新",
      col_actions: "操作",
      send_email: "メールを送る",
      mail_subject: "MABWからのごあいさつ",
      mail_body: "{name}さん、\n\nコミュニティにご参加いただきありがとうございます。MABWよりお礼を申し上げます。\n\n今後ともよろしくお願いいたします。\nDemetrio Campolo — MABW · Make A Better World\nhttps://webmabw.com\ninfo@webmabw.com",
      compose_title: "{name}さんにメールを送る",
      compose_from: "送信者",
      compose_from_value: "Demetrio Campolo — info@webmabw.com",
      compose_to: "宛先",
      compose_subject: "件名",
      compose_body: "本文",
      compose_send: "送信する",
      compose_sending: "送信中…",
      compose_cancel: "キャンセル",
      compose_sent: "{email}にメールを送信しました",
      compose_error: "送信に失敗しました：{err}",
    },
    legal: {
      impressum: "法的通知",
      privacy: "プライバシー",
    },
  },
};

export default translations;
